import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { FormTemplateGridService } from "./../services/form-template-grid.service";
import { ZpDataService } from "./../services/zp-data.service";
import { IDataGrid } from "./../models/data-grid.model";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "./../models/user.model";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { Location } from "@angular/common";
import { NotificationService } from "../services/notification.service";
import { ZPNotification } from "../models/zpnotification";
import { ThemeService } from "../theme/theme-service.service";

@Component({
  selector: "app-dynamic-grid",
  templateUrl: "./dynamic-grid.component.html",
  styleUrls: ["./dynamic-grid.component.scss"],
})
export class DynamicGridComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  public mySubscription: any;
  public templateName: string;
  public newItem: any;
  Id: any;
  action: any;
  public editItem;
  myFormTemplate: IDataGrid;
  myTemplateParam;
  public itemList;
  myItemList;
  public myItemList2;
  itemName;
  public reviewStatus;
  deleteId;
  showDialog = false;
  public localData;
  public sectionTitle: string;
  public visible = false;
  myResult;
  public itemToDeleteId;
  public itemNameforDialog;
  public noItems = false;
  public myUser: IUser;
  public viewOnly = false;
  public canEdit = true;
  public markedComplete = false;
  public showAddButton = true;
  public showDeleteButton = true;
  public delegatesList = false;
  public delegatesById: {}[] = [];
  public changedByList: {}[] = [];
  public collapsed = [];
  public noItemDeleted = false;
  public dataIsLoaded: boolean = false;
  public hasPlan;
  public showOvaleDiv: boolean;
  public registered: boolean = false;
  public activeTheme: any;
  public isDefaultTheme: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formTemplateGridService: FormTemplateGridService,
    private zenplansDataService: ZpDataService,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private notificationService: NotificationService,
    public themeService: ThemeService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.templateName = params.get("templateName");
      this.action = params.get("action");
    });
    this.subscription = this.userInfo.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
    });
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    this.dataIsLoaded = false;
    await this.fillFormTemplateInfo(this.templateName);
    this.sectionTitle = this.myFormTemplate.sectionTitle;
    if (this.sectionTitle.toLowerCase().includes("general expenses")) {
      this.showAddButton = false;
      this.showDeleteButton = false;
    }

    this.subscription = this.zenplansDataService.currentMessage.subscribe(
      async (message) => {
        this.zenplansDataService
          .getSection(this.myFormTemplate.sectionTitle)
          .then(async (section) => {
            if (section && section.length > 0) {
              this.itemList = section;
              this.myItemList = this.itemList;

              console.log("this.myItemList", this.myItemList)
              let i = 0;
              this.myItemList.map((item) => {
                console.log('item', item)
                if (item.digitalLifePermission === undefined) {
                  item.digitalLifePermission = 'future';
                  console.log("this.myItemList", this.myItemList)
                }
                this.collapsed[i++] = false;
              });
              this.myItemList2 = this.itemList;
              let now = new Date();
              let listLength = this.myItemList.length;
              let changedByName = "";
              let loggeInUserName =
                this.myUser.firstName + " " + this.myUser.lastName;
              let changedBy = {};
              for (var counter = 0; counter < listLength; counter++) {
                changedByName = "";
                if (this.myItemList[counter].lastUpdateBy == this.myUser.Id) {
                  changedByName = loggeInUserName;
                } else {
                  changedBy = this.changedByList.find(
                    (changer) =>
                      changer["Id"] == this.myItemList[counter].lastUpdateBy
                  );
                  //building a list of user names to minimize round trips
                  if (!changedBy) {
                    changedByName = await this.zenplansDataService.getUserName(
                      this.myItemList[counter].lastUpdateBy
                    );
                    this.changedByList.push({
                      Id: this.myItemList[counter].lastUpdateBy,
                      name: changedByName,
                    });
                  } else {
                    changedByName = changedBy["name"];
                  }
                }
                this.myItemList[counter].lastUpdateByName = changedByName; //await this.zenplansDataService.getUserName(kk.lastUpdateBy);
                if (!this.myItemList[counter].lastUpdateByName) {
                  this.myItemList[counter].lastUpdateByName = "Unknown";
                }
                if (
                  !this.myItemList[counter].itemName &&
                  this.myItemList[counter].firstName &&
                  this.myItemList[counter].lastName
                ) {
                  //for delegates for example where therre is no itemname
                  //We will also need a grid for users for the professionals
                  //and for zenplans admin
                  this.myItemList[counter].itemName =
                    this.myItemList[counter].firstName +
                    " " +
                    this.myItemList[counter].lastName;
                }
              }
              this.noItems = false;
              this.dataIsLoaded = true;
            } else {
              this.dataIsLoaded = true;
              this.noItems = true;
            }

            this.delegatesList = true;
            //check which delegates are registered
            //in order to toggle the remind button
            let indexcounter = 0;
          });
      }
    );
  }

  async refresh() {
    await this.zenplansDataService.revalidateCache();
    this.zenplansDataService.changeMessage(
      JSON.stringify({ "cache revalidated": true })
    );
  }

  async fillFormTemplateInfo(templateName: string) {
    await this.formTemplateGridService
      .getFormTemplateAsync(templateName)
      .then(async (kk) => {
        this.myFormTemplate = kk;
        let mySectionTitle = kk.sectionTitle;
        return mySectionTitle;
      });
  }

  add() {
    this.router.navigate(["/" + this.myFormTemplate.addUrl]);
  }

  view(id: string) {
    this.router.navigate(["/" + this.myFormTemplate.viewUrl + "/" + id]);
  }

  edit(id: string) {
    this.router.navigate(["/" + this.myFormTemplate.editUrl + "/" + id]);
  }

  async deleteByEvent(choice) {
    this.showDialog = !this.showDialog;
    if (choice === "Yes") {
      this.notificationService.changeMessage(
        new ZPNotification(
          "Delegate deleted.",
          undefined,
          undefined,
          "Your delegate was permanently deleted. You will need to add them again if you would like to restore them to your plan."
        )
      );
      let clientId = this.myUser.sharedPlanUserId
        ? this.myUser.sharedPlanUserId
        : this.myUser.Id;
      var itemAboutToBeDeleted = await this.zenplansDataService.getItem(
        this.itemToDeleteId,
        this.sectionTitle,
        clientId
      );
      await this.zenplansDataService.deleteDelegate(
        this.itemToDeleteId,
        this.myFormTemplate.sectionTitle,
        clientId
      );
      var Id: string;
      if (this.myUser.sharedPlanUserId) {
        Id = this.myUser.sharedPlanUserId;
      } else {
        Id = this.myUser.Id;
      }
      this.refresh();
      this.zenplansDataService.addLog(
        this.sectionTitle,
        this.itemToDeleteId,
        Id,
        "",
        JSON.stringify(itemAboutToBeDeleted),
        "",
        "delete"
      );
    }
  }

  async callDialog(id, name) {
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
